<template>
  <div class="NeedOrder">
    <ld-header
      transparent
      @click-left="$router.push({ path: '/userCenter' })"
    />
    <van-tabs
      v-model="id"
      line-width="20px"
      line-height="2px"
      animated
      swipeable
      sticky
    >
      <van-tab
        name="1"
        title="机票"
      >
        <div class="wrapper">
          <mescroll-vue
            ref="mescroll"
            :down="{use: false}"
          >
            <van-list
              v-model="interPage.loading"
              :finished="interPage.finished"
              :error.sync="interPage.error"
              :error-text="interPage.errorText"
              :finished-text="interPage.finishedText"
              @load="getInterNeedOrderList(interPage.pageNum++)"
            >
              <van-row
                class="common-item bg-white"
                v-for="inter in interList"
                :key="inter.id"
                type="flex"
                @click="$router.push({ path: `/tk/tkNeedDetail?orderId=${inter.id}` })"
              >
                <van-col :span="2">
                  <ld-icon
                    size="24"
                    class="main-color"
                    type="iconweibiaoti-1"
                  />
                </van-col>
                <van-col
                  :span="21"
                  :offset="1"
                >
                  <p class="fr main-color">
                    {{ inter.orderStatusRemark }}
                  </p>
                  <div
                    v-for="order in inter.interNeedOrders"
                    :key="order.arriveAirport"
                  >
                    <h4>{{ order.departCityName }} - {{ order.arriveCityName }}</h4>
                    <div class="common-item__label">
                      {{ $t('C106','出发日期') }}：{{ order.departTime }} {{ order.week }}
                    </div>
                  </div>
                  <div class="common-item__label">
                    成人数量：{{ inter.adultNum }} &nbsp;&nbsp;
                    婴儿数：{{ inter.babyNum }} &nbsp;&nbsp;
                    儿童数：{{ inter.childNum }} &nbsp;&nbsp;
                  </div>
                  <div class="common-item__label">
                    {{ inter.linkman }} &nbsp;&nbsp; {{ inter.linkTel }}
                  </div>
                </van-col>
              </van-row>
            </van-list>
          </mescroll-vue>
        </div>
      </van-tab>


      <van-tab
        name="2"
        title="酒店"
      >
        <div class="wrapper">
          <mescroll-vue
            ref="mescroll"
            :down="{use: false}"
          >
            <van-list
              v-model="hotelPage.loading"
              :finished="hotelPage.finished"
              :error.sync="hotelPage.error"
              :error-text="hotelPage.errorText"
              :finished-text="hotelPage.finishedText"
              @load="getHotelNeedOrderList(hotelPage.pageNum++)"
            >
              <van-row
                class="common-item bg-white"
                v-for="(order, i) in hotelList"
                :key="i"
                type="flex"
                @click="$router.push({ path: `/ht/htQuery/htInquiryDetail/${order.id}` })"
              >
                <van-col :span="2">
                  <ld-icon
                    size="24"
                    class="main-color"
                    type="iconweibiaoti-13"
                  />
                </van-col>
                <van-col
                  :offset="1"
                  :span="21"
                >
                  <p class="fr main-color">
                    {{ order.ddztRemark }}
                  </p>
                  <h4 class="common-item__title">
                    {{ order.cityName }}-{{ order.jdmc }}
                  </h4>
                  <div class="common-item__label">
                    <span>{{ order.rzrq }}</span> {{ $t('H041','至') }} <span>{{ order.ldrq }}</span>&nbsp;&nbsp;
                    <span>{{ order.nights }}晚 /{{ order.rooms }}{{ $t('E205','间') }}</span>
                  </div>
                  <div class="common-item__label">
                    {{ order.fxmc }}
                  </div>
                  <div class="common-item__label">
                    {{ order.linkman }}
                  </div>
                </van-col>
              </van-row>
            </van-list>
          </mescroll-vue>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Tab, Tabs, List } from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'
import interNeedOrderInteractor from './use-cases/interNeedOrder-interactor'
import hotelNeedOrderInteractor from './use-cases/hotelNeedOrder-interactor'

export default {
  name: 'NeedOrder',
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    MescrollVue
  },
  // props: {
  // 	id: {
  // 		type: String,
  // 		default: '1'
  // 	}
  // },
  data() {
    return {
      id: '1',
      interPage: {
        pageNum: 0,
        count: 10,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载'
      },
      interList: [],
      hotelPage: {
        pageNum: 0,
        count: 10,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载'
      },
      hotelList: [],
    }
  },
  created() {
    if (this.$route.query.type) this.id = '2'
  },
  methods: {
    /**
     * 获取国际机票需求单列表
     */
    async getInterNeedOrderList () {
      try {
        if (this.interPage.pageNum === 0) return

        this.interPage.loading = true
        let params = {
          dateStart: '2018-01-01',
          dateEnd: '2099-01-01',
          pageNum: this.interPage.pageNum,
          count: this.interPage.count
        }
        const { data } = await interNeedOrderInteractor.getInterNeedOrderList(params)
        
        this.interPage.loading = false
        if (data.length < 10) {
          this.interPage.finished = true
        }
        if (params.pageNum > 1) {
          this.interList.push(...data)
        } else {
          this.interList = data
        }
        
      } catch (error) {
        this.interPage.error = true
      }
    },
    /**
     * 获取国际酒店需求单列表
     */
    async getHotelNeedOrderList () {
      try {
        this.hotelPage.loading = true
        
        let params = {
          lookPriceDateStart: '2018-01-01',
          lookPriceDateEnd: '2099-01-01',
          pageNum: this.hotelPage.pageNum,
          count: this.hotelPage.count
        }
        const { data } = await hotelNeedOrderInteractor.getHotelNeedOrderList(params)
        
        this.hotelPage.loading = false
        this.hotelPage.finished = true

        this.hotelList = data
        
      } catch (error) {
        this.hotelPage.error = true
      }
    }
  }
}
</script>

<style lang="less">
.NeedOrder {
  .wrapper {
    height: calc(100vh - 93px);
    overflow: hidden;
    padding: 0 8px;
  }

  .van-tabs__nav {
    background-color: transparent;
  }
  .van-search__content {
    background-color: #fff;
  }
  .van-tabs__wrap {
    width: 300px;

    .van-tab--active {
      font-size: @font-size-20;
      z-index: 1;
    }
  }

  .common-item {
    padding: 13px 15px;
    border-radius: @border-radius-sm;
    margin-top: 5px;

    .common-item__label {
      margin-top: 2px;
      margin-bottom: 4px;
      font-size: @font-size-12;
      color: @color-text-gray;
    }
  }
}
</style>
